import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Avatar from "react-avatar";
import { Link } from "react-router-dom";
import "./styles.css";
import SignIn from "../Authentication/Signin";
import LogoutButton from "../Authentication/Signout";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useState, useEffect } from "react";
import { useGlobalState } from "../GlobalContext";
import { toast } from "react-toastify";
import textProperties from "../utils/textProperties";
import PurchasedSites from "../PurchasedSites/PurchasedSites";

export default function PositionedMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user, setUser] = useState(null);
  const [openIt, setOpen] = useState(false);
  const { updateOpenPurchased, openPurchased, updateUserRole } = useGlobalState();
  const [isAdmin, setIsAdmin] = useState(false);
  const open = Boolean(anchorEl);

    async function getRefreshedToken() {
      try {
        if (user) {
          const idToken = await user.getIdTokenResult();
          if(idToken?.claims?.role === 'admin') {
            setIsAdmin(true);
            updateUserRole(idToken?.claims?.role);
          }
        }
      } catch (error) {
        console.error("Error refreshing token:", error);
        return null;
      }
    }

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      setUser(authUser);
      getRefreshedToken();
    });

    return () => unsubscribe();
  }, [user]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePurchased = () => {
    setOpen(!openIt);
    updateOpenPurchased(!openPurchased);
    handleClose();
  };

  return (
    <div>
      <div
        className="menu-container"
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {user ? (
          <span className="MenubarIcon">
            <MenuRoundedIcon />
            {user?.displayName === null ? (
              <AccountCircleIcon />
            ) : (
              <Avatar
                name={user?.displayName}
                round={true}
                size="25"
                textSizeRatio={2}
                color="#ea5355"
                style={{ marginBottom: "17px" }}
              />
            )}
          </span>
        ) : (
          <span className="MenubarIcon">
            <MenuRoundedIcon />
            <AccountCircleIcon />
          </span>
        )}
      </div>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          ".MuiPaper-root": {
            borderRadius: "1rem",
            marginTop: "0.5rem",
            boxShadow: "0 0px 5px 0 rgba(67, 66, 66, 0.2)",
            minWidth: "200px",
            overflow: "visible",
          },
        }}
        disableScrollLock={true}
      >
        {!user ? (
          <MenuItem className="signin-menubar">
            <SignIn value={"Sign in"} width={"180px"}/>
          </MenuItem>
        ) : (
          <MenuItem className="signup">
            <LogoutButton width={"180px"}/>
          </MenuItem>
        )}
        {!user ? (
          <Link to="/signup">
            <MenuItem onClick={handleClose} className="signup">
              {textProperties.signUp}
            </MenuItem>
          </Link>
        ) : null}
        {user?.emailVerified && <hr />}
        {user?.emailVerified && (
          <Link to="/profile">
            <MenuItem onClick={handleClose} className="cpoassistprofile">
              {textProperties.profile}
            </MenuItem>
          </Link>
        )}

        {user?.emailVerified && (
          <Link to="/cart">
            <MenuItem onClick={handleClose} className="cart">
              {textProperties.myCart}{" "}
            </MenuItem>
          </Link>
        )}
        {user?.emailVerified && (
          <MenuItem
            onClick={() => handlePurchased(!openIt)}
            className="cart cpoassistprofile"
          >
            {textProperties.purchasedSites}{" "}
          </MenuItem>
        )}
        {isAdmin && <hr />}
        {isAdmin && (
          <Link to="/admin-portal">
            <MenuItem onClick={handleClose} className="helpcenter">
              {textProperties.adminPortal}
            </MenuItem>
          </Link>
        )}
      </Menu>
      {openPurchased && <PurchasedSites />}
    </div>
  );
}
